export default "__VITE_ASSET__BiEHY5ju__"